import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { NAMESPACE } from '../acessibilidadePainel/i18n';
import { botaoDoVLibras } from '../acessibilidadePainel/vlibras';

// Botão "Ocultar Libras" (×) colado acima do botão do VLibras: o jeito óbvio
// de tirar o widget da tela sem ir ao painel de Acessibilidade. O × do próprio
// VLibras só fecha o avatar; o botão azul continua. Este desliga a opção.
//
// O botão do VLibras fica num shadow DOM (fixed, à direita, no meio da tela) e
// some enquanto o avatar está aberto: aí este também some, para não ficar por
// cima do avatar. A posição é lida do botão dele, então acompanha a tela.
export const TAMANHO = 28;
const VAO = 6;
const INTERVALO_MS = 500;

export const posicaoAoLado = (r) => {
  if (!r || r.width <= 0 || r.height <= 0) return null;
  const left = Math.round(r.left + (r.width - TAMANHO) / 2);
  let top = Math.round(r.top - TAMANHO - VAO);
  // Sem espaço acima (botão arrastado para o topo): vai para baixo.
  if (top < 4) top = Math.round(r.top + r.height + VAO);
  return { left, top };
};

const mesmaPosicao = (a, b) => (a === b) || (a && b && a.left === b.left && a.top === b.top);

const OcultarVLibras = ({ aoOcultar }) => {
  const { t } = useTranslation(NAMESPACE);
  const [posicao, setPosicao] = useState(null);

  useEffect(() => {
    const medir = () => {
      const botao = botaoDoVLibras();
      // Com "Tamanho da fonte" o <html> tem zoom: o retângulo vem já ampliado
      // e o left/top do estilo é ampliado de novo. Divide pelo zoom.
      const zoom = parseFloat(window.getComputedStyle(document.documentElement).zoom) || 1;
      const r = botao?.getBoundingClientRect();
      const nova = r ? posicaoAoLado({ left: r.left / zoom, top: r.top / zoom, width: r.width / zoom, height: r.height / zoom }) : null;
      setPosicao((atual) => (mesmaPosicao(atual, nova) ? atual : nova));
    };
    medir();
    const timer = window.setInterval(medir, INTERVALO_MS);
    window.addEventListener('resize', medir);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('resize', medir);
    };
  }, []);

  if (!posicao) return null;

  return createPortal(
    <button
      type="button"
      className="a11y-vlibras-ocultar"
      style={{ left: posicao.left, top: posicao.top }}
      onClick={aoOcultar}
      aria-label={t('vlibrasHide')}
      title={t('vlibrasHide')}
      data-testid="a11y-vlibras-ocultar"
    >
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true" focusable="false">
        <line x1="6" y1="6" x2="18" y2="18" />
        <line x1="18" y1="6" x2="6" y2="18" />
      </svg>
    </button>,
    document.body
  );
};

export default OcultarVLibras;
